<template>
  <div class="kanban-board">
    <div class="kanban-columns">
      <div
        v-for="status in taskStatuses"
        :key="status.value"
        class="kanban-column"
      >
        <div
          class="kanban-column-header"
          :style="{ borderTopColor: status.color }"
        >
          <h4 class="mb-0">
            {{ status.label }}
            <b-badge
              :variant="status.badgeVariant"
              pill
              class="mr-50"
            >
              {{ getTasksByStatus(status.value).length }}
            </b-badge>
          </h4>
        </div>

        <vue-perfect-scrollbar
          :settings="perfectScrollbarSettings"
          class="kanban-column-content"
        >
          <draggable
            :list="getTasksByStatus(status.value)"
            :group="{ name: 'tasks' }"
            class="kanban-cards"
            ghost-class="ghost-card"
            :animation="200"
            @change="onDragChange($event, status.value)"
          >
            <b-card
              v-for="task in getTasksByStatus(status.value)"
              :key="task.id"
              class="kanban-card mb-1 cursor-pointer"
              @click="openTaskDetails(task)"
            >

              <div class="d-flex justify-content-between align-items-start mb-75">
                <h5 class="mb-0">
                  {{ getTaskName(task) }}
                </h5>
                <!-- <b-dropdown
                  variant="link"
                  no-caret
                  toggle-class="p-0"
                  right
                  @click.stop
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="text-body"
                    />
                  </template>
                  <b-dropdown-item @click.stop="editTask(task)">
                    <feather-icon icon="EditIcon" size="16" class="mr-50" />
                    <span>تعديل</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click.stop="viewTaskDetails(task)">
                    <feather-icon icon="EyeIcon" size="16" class="mr-50" />
                    <span>عرض التفاصيل</span>
                  </b-dropdown-item>
                </b-dropdown> -->
              </div>

              <p
                v-if="task.description"
                class="card-text mb-75"
              >
                {{ truncateText(task.description, 100) }}
              </p>

              <div
                v-if="task.tags && task.tags.length"
                class="d-flex flex-wrap mb-50"
              >
                <b-badge
                  v-for="(tag, index) in task.tags"
                  :key="index"
                  :variant="getTagVariant(tag)"
                  pill
                  class="mr-50 mb-25"
                >
                  {{ tag }}
                </b-badge>
              </div>

              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-1">
                    <!-- {{ task.due_date || task.created_at | formatDate }}  -->
                    {{ getTaskEstimatedHours(task) }}
                  </small>
                  <feather-icon
                    icon="ClockIcon"
                    size="14"
                    class="text-muted"
                  />

                </div>

                <div
                  v-if="task.assigned_user"
                  class="d-flex align-items-center"
                >
                  <b-avatar
                    :src="getAssignedUserAvatar(task)"
                    :text="avatarText(getAssignedUserName(task))"
                    size="24"
                    variant="light-primary"
                  />
                </div>
              </div>

              <div
                v-if="task.priority"
                class="mt-50"
              >
                <b-badge :variant="getPriorityVariant(task.priority)">
                  {{ task.priority }}
                </b-badge>
              </div>
            </b-card>
          </draggable>

          <div
            v-if="getTasksByStatus(status.value).length === 0"
            class="text-center py-3"
          >
            <p class="text-muted mb-0">
              لا توجد مهام
            </p>
          </div>
        </vue-perfect-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BBadge,
  BAvatar,
  BDropdown,
  BDropdownItem,
} from 'bootstrap-vue'
import draggable from 'vuedraggable'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { avatarText } from '@core/utils/filter'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'TasksKanbanView',
  components: {
    BCard,
    BBadge,
    BAvatar,
    BDropdown,
    BDropdownItem,
    draggable,
    VuePerfectScrollbar,
  },
  filters: {
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      return d.toLocaleDateString('ar-EG', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      })
    },
  },
  props: {
    tasks: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      taskStatuses: [
        {
          value: 'pending',
          label: 'قيد الانتظار',
          color: '#FF9F43',
          badgeVariant: 'light-warning',
        },
        {
          value: 'in_progress',
          label: 'قيد التنفيذ',
          color: '#00CFE8',
          badgeVariant: 'light-info',
        },
        {
          value: 'review',
          label: 'قيد المراجعة',
          color: '#06284D',
          badgeVariant: 'light-primary',
        },
        {
          value: 'completed',
          label: 'مكتملة',
          color: '#28C76F',
          badgeVariant: 'light-success',
        },
      ],
      perfectScrollbarSettings: {
        maxScrollbarLength: 150,
        wheelPropagation: false,
      },
    }
  },
  methods: {
    avatarText,
    getTasksByStatus(status) {
      return this.tasks.filter(task => task.status === status)
    },
    getTaskName(task) {
      return (task.project_service_action && task.project_service_action.name) || 'بدون اسم'
    },
    getTaskEstimatedHours(task) {
      return (task.project_service_action && task.project_service_action.estimated_hours) || '-'
    },
    getAssignedUserAvatar(task) {
      return (task.assigned_user && task.assigned_user.avatar) || null
    },
    getAssignedUserName(task) {
      return (task.assigned_user && task.assigned_user.name) || ''
    },
    truncateText(text, length) {
      if (!text) return ''
      return text.length > length ? `${text.substring(0, length)}...` : text
    },
    getTagVariant(tag) {
      const variants = {
        urgent: 'danger',
        high: 'warning',
        medium: 'info',
        low: 'success',
      }
      return variants[tag.toLowerCase()] || 'secondary'
    },
    getPriorityVariant(priority) {
      const variants = {
        urgent: 'danger',
        high: 'warning',
        medium: 'info',
        low: 'success',
      }
      return variants[priority.toLowerCase()] || 'secondary'
    },
    async onDragChange(event, newStatus) {
      if (event.added) {
        const task = event.added.element
        const oldStatus = task.status

        // Optimistically update the UI
        task.status = newStatus

        try {
          await this.$store.dispatch('tasks/updateTaskStatus', {
            taskId: task.id,
            status: newStatus,
          })

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'تم تحديث الحالة',
              icon: 'CheckIcon',
              variant: 'success',
              text: 'تم تحديث حالة المهمة بنجاح',
            },
          })

          // Refresh tasks
          this.$emit('refresh')
        } catch (error) {
          // Revert on error
          task.status = oldStatus
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'خطأ',
              icon: 'XIcon',
              variant: 'danger',
              text: 'فشل تحديث حالة المهمة',
            },
          })
        }
      }
    },
    openTaskDetails(task) {
      this.$router.push({ name: 'taskDetails', params: { id: task.id } })
    },
    editTask(task) {
      this.$emit('edit-task', task)
    },
    viewTaskDetails(task) {
      this.$router.push({ name: 'taskDetails', params: { id: task.id } })
    },
  },
}
</script>

<style lang="scss" scoped>
.kanban-board {
  width: 100%;
  overflow-x: auto;
  padding-bottom: 1rem;
}

.kanban-columns {
  display: flex;
  gap: 1.5rem;
  min-height: calc(100vh - 300px);
}

.kanban-column {
  min-width: 250px;
  max-width: 280px;
  flex: 1;
  background-color: #f8f8f8;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
}

.kanban-column-header {
  padding: 1rem;
  border-top: 3px solid;
  border-radius: 0.5rem 0.5rem 0 0;
  background-color: white;

  h4 {
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.kanban-column-content {
  flex: 1;
  padding: 1rem;
  max-height: calc(100vh - 350px);
  overflow-y: auto;
}

.kanban-cards {
  min-height: 100px;
}

.kanban-card {
  cursor: grab;
  transition: all 0.2s ease;
  border: 1px solid #e9ecef;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  &:active {
    cursor: grabbing;
  }
}

.ghost-card {
  opacity: 0.5;
  background: #f8f9fa;
}

@media (max-width: 768px) {
  .kanban-columns {
    flex-direction: column;
  }

  .kanban-column {
    max-width: 100%;
    min-width: 100%;
  }
}
</style>
